import $ from 'jquery'

let initialized = false

function initAdminSnoozeModal() {
  if (initialized || !document.getElementById('snoozeModal')) {
    return
  }
  initialized = true

  let snoozeHoldTimer = null
  let snoozeInfHoldCompleted = false
  let snoozeSubmitLabelHtml = null
  let snoozeAjaxPending = false
  const snoozeInfHoldMs = 5000
  let snoozeInfHoldStartMs = 0
  let snoozeHoldReleaseHandler = null
  let snoozeCapturedPointerId = null

  function syncInfiniteSnoozePanelsVisibility() {
    const isInf = $('#snooze-duration').val() === 'inf'
    const $wrap = $('#snooze-inf-hold-progress-wrap')
    if (isInf) {
      $('#snooze-inf-loud-warning').show()
      $wrap.removeClass('d-none').addClass('invisible')
    } else {
      $('#snooze-inf-loud-warning').hide()
      $wrap.addClass('d-none').removeClass('invisible')
    }
  }

  function unbindHoldReleaseListeners() {
    if (snoozeHoldReleaseHandler) {
      document.removeEventListener('pointerup', snoozeHoldReleaseHandler, true)
      document.removeEventListener('pointercancel', snoozeHoldReleaseHandler, true)
      snoozeHoldReleaseHandler = null
    }
    $(document).off('.snoozeHoldRel')
    if (snoozeCapturedPointerId !== null && snoozeCapturedPointerId !== undefined) {
      const btn = document.getElementById('snooze-submit')
      if (btn) {
        try {
          btn.releasePointerCapture(snoozeCapturedPointerId)
        } catch (err) {
        }
      }
      snoozeCapturedPointerId = null
    }
  }

  function bindHoldReleaseListeners(nativeEv) {
    if (typeof nativeEv.pointerId === 'number') {
      const pid = nativeEv.pointerId
      snoozeHoldReleaseHandler = function(domEv) {
        if (domEv.pointerId !== pid) {
          return
        }
        unbindHoldReleaseListeners()
        endSnoozeInfHold()
      }
      document.addEventListener('pointerup', snoozeHoldReleaseHandler, true)
      document.addEventListener('pointercancel', snoozeHoldReleaseHandler, true)
    } else {
      $(document).on('mouseup.snoozeHoldRel touchend.snoozeHoldRel touchcancel.snoozeHoldRel', function() {
        unbindHoldReleaseListeners()
        endSnoozeInfHold()
      })
    }
  }

  function clearSnoozeHoldTimer() {
    unbindHoldReleaseListeners()
    if (snoozeHoldTimer) {
      clearInterval(snoozeHoldTimer)
      snoozeHoldTimer = null
    }
    $('#snooze-inf-hold-progress-bar').css('width', '0%').attr('aria-valuenow', 0)
    const $btn = $('#snooze-submit')
    $btn.removeClass('snooze-hold-in-progress')
    if (snoozeSubmitLabelHtml !== null) {
      $btn.html(snoozeSubmitLabelHtml)
      snoozeSubmitLabelHtml = null
    }
    syncInfiniteSnoozePanelsVisibility()
  }

  function resetSnoozeHoldState() {
    clearSnoozeHoldTimer()
    snoozeInfHoldCompleted = false
  }

  function performSnoozeSubmit() {
    const duration = $('#snooze-duration').val()
    const note = $('#snooze-note').val()

    if (!duration) {
      alert('Please select a snooze duration.')
      return false
    }

    if (!note || note.trim() === '') {
      alert('Please enter a note explaining why you are snoozing this notification.')
      return false
    }

    if (snoozeAjaxPending) {
      return false
    }

    const notificationId = $('#snooze-notification-id').val()

    snoozeAjaxPending = true

    $.ajax({
      url: '/admin/notifications/' + notificationId + '/snooze',
      method: 'PATCH',
      data: {
        duration: duration,
        note: note
      },
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      complete: function() {
        snoozeAjaxPending = false
      },
      success: function() {
        $('#snoozeModal').modal('hide')
        location.reload()
      },
      error: function(xhr) {
        const errorMsg = xhr.responseJSON ? xhr.responseJSON.error : 'An error occurred while snoozing the notification.'
        alert(errorMsg)
      }
    })

    return true
  }

  function endSnoozeInfHold() {
    if ($('#snooze-duration').val() !== 'inf') {
      return
    }
    if (snoozeInfHoldCompleted) {
      return
    }
    clearSnoozeHoldTimer()
  }

  function startSnoozeInfHold(nativeEv) {
    if ($('#snooze-duration').val() !== 'inf') {
      return
    }
    clearSnoozeHoldTimer()
    if (nativeEv && typeof nativeEv.pointerId === 'number') {
      const btnEl = document.getElementById('snooze-submit')
      if (btnEl) {
        try {
          btnEl.setPointerCapture(nativeEv.pointerId)
          snoozeCapturedPointerId = nativeEv.pointerId
        } catch (err) {
        }
      }
    }
    bindHoldReleaseListeners(nativeEv || {})
    const $btn = $('#snooze-submit')
    snoozeSubmitLabelHtml = $btn.html()
    $btn.addClass('snooze-hold-in-progress')
    $btn.text('Hold 5s…')
    $('#snooze-inf-hold-progress-wrap').removeClass('invisible')
    snoozeInfHoldStartMs = Date.now()
    snoozeHoldTimer = setInterval(function() {
      const elapsed = Date.now() - snoozeInfHoldStartMs
      const pct = Math.min(100, (elapsed / snoozeInfHoldMs) * 100)
      $('#snooze-inf-hold-progress-bar').css('width', pct + '%').attr('aria-valuenow', Math.round(pct))
      if (elapsed >= snoozeInfHoldMs) {
        clearInterval(snoozeHoldTimer)
        snoozeHoldTimer = null
        snoozeInfHoldCompleted = true
        clearSnoozeHoldTimer()
        performSnoozeSubmit()
      }
    }, 32)
  }

  $(document).on('click', '.snooze-link', function(e) {
    e.preventDefault()
    const notificationId = $(this).data('notificationId')
    $('#snooze-notification-id').val(notificationId)
    $('#snooze-form').attr('action', '/admin/notifications/' + notificationId + '/snooze')
    $('#snooze-duration').val('')
    $('#snooze-note').val('')
    $('.snooze-duration-btn').removeClass('active')
    $('#snoozeModal').modal('show')
  })

  $('#snoozeModal').on('hidden.bs.modal shown.bs.modal', function() {
    resetSnoozeHoldState()
  })

  $('.snooze-duration-btn').on('click', function() {
    $('.snooze-duration-btn').removeClass('active')
    $(this).addClass('active')
    $('#snooze-duration').val($(this).data('duration'))
    resetSnoozeHoldState()
  })

  const $snoozeSubmit = $('#snooze-submit')
  if (window.PointerEvent) {
    $snoozeSubmit.on('pointerdown', function(e) {
      if ($('#snooze-duration').val() !== 'inf') {
        return
      }
      const ne = e.originalEvent || e
      if (ne.pointerType === 'mouse' && ne.button !== 0) {
        return
      }
      startSnoozeInfHold(ne)
    })
  } else {
    $snoozeSubmit.on('mousedown', function(e) {
      if ($('#snooze-duration').val() !== 'inf') {
        return
      }
      if (e.button !== 0) {
        return
      }
      startSnoozeInfHold({})
    })
    $snoozeSubmit.on('touchstart', function(e) {
      if ($('#snooze-duration').val() !== 'inf') {
        return
      }
      e.preventDefault()
      startSnoozeInfHold({})
    })
  }

  $snoozeSubmit.on('click', function() {
    const duration = $('#snooze-duration').val()
    if (duration !== 'inf') {
      performSnoozeSubmit()
      return
    }
    snoozeInfHoldCompleted = false
  })
}

document.addEventListener('DOMContentLoaded', initAdminSnoozeModal)
